import React, { useState, useEffect } from 'react'
import { Typography, withStyles, Collapse, IconButton } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import { CoreTextField } from 'src/components/core'

const HeaderSettingsCollectionLanguageAccordion = ({
  classes,
  onButtonTextChange,
  isLoading,
  landingPageData,
  selectedReadMoreValue,
  selectedStartValue,
  previewType,
  isShowcaseCollection,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [readMoreText, setReadMoreText] = useState('See more')
  const [getStartedText, setGetStartedText] = useState('Get Started')

  useEffect(() => {
    setReadMoreText(landingPageData?.localizations?.readMore || 'See more')
    setGetStartedText(
      landingPageData?.localizations?.startButton || 'Get Started',
    )
  }, [landingPageData])

  // Update local state when props change
  useEffect(() => {
    setReadMoreText(selectedReadMoreValue)
    setGetStartedText(selectedStartValue)
  }, [selectedReadMoreValue, selectedStartValue])

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  const handleChangeReadMore = value => {
    setReadMoreText(value)
    onButtonTextChange('readMore', value)
  }

  const handleChangeGetStarted = value => {
    setGetStartedText(value)
    onButtonTextChange('start', value)
  }

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer} onClick={handleToggleExpanded}>
        <Typography className={classes.header}>Language</Typography>
        <IconButton
          className={classes.expandButton}
          onClick={handleToggleExpanded}
          size="small"
        >
          <Icon
            icon={
              isExpanded
                ? 'material-symbols:keyboard-arrow-up'
                : 'material-symbols:keyboard-arrow-down'
            }
            className={classes.expandIcon}
          />
        </IconButton>
      </div>

      <Collapse
        in={isExpanded}
        timeout="auto"
        unmountOnExit
        className={classes.collapse}
      >
        <div className={classes.content}>
          {/* Get Started button - Show for both type 2 and type 3, but NOT for showcase collections */}
          {!isShowcaseCollection && (
            <CoreTextField
              value={getStartedText}
              onChange={e => handleChangeGetStarted(e.target.value)}
              fullWidth
              label="Get Started"
              placeholder="Get Started"
              disabled={isLoading}
            />
          )}

          {/* See More button - Only show for type 2 */}
          {previewType === 2 && (
            <CoreTextField
              value={readMoreText}
              onChange={e => handleChangeReadMore(e.target.value)}
              fullWidth
              label="See more"
              placeholder="See more"
              disabled={isLoading}
            />
          )}
        </div>
      </Collapse>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsCollectionLanguageAccordion)
